import { useQuery } from "react-query";
import { authAxios as axios } from "shared-auth";
import { config } from "../../../../../../config";

export interface IPerformer {
  forename: string;
  surname: string;
  performerType: string;
  viewPin: string;
}

export const unifyUrlsConfigs = (url: string) =>
  url.endsWith("/") ? url.slice(0, -1) : url;

export const cdSearchQueryKey = "cd-agent-performer-search";

export function useGetPerformerSearch(searchTerm: string) {
  return useQuery([cdSearchQueryKey, searchTerm], {
    queryFn: async () => {
      const { data } = await axios.post<{
        profiles: IPerformer[];
        total: number;
      }>(`${unifyUrlsConfigs(config.searchAndFiltersApiUrl)}/search`, {
        skip: 0,
        take: 11,
        performerName: searchTerm,
        orderBy: "Relevance",
      });

      return data.profiles.map((item) => ({
        name: `${item.forename} ${item.surname}`,
        data: {
          url: `${unifyUrlsConfigs(config.siteRootUrl)}/${item.viewPin}`,
          type: item.performerType,
        },
      }));
    },
    enabled: !!searchTerm,
  });
}
